import*as e from"react";import t from"linkify-react";const o=({children:o,shouldOpenInNewTab:r})=>e.createElement(t,{options:r?{target:"_blank"}:void 0},o);export{o as Linkify};
//# sourceMappingURL=linkify.js.map
